import React from 'react';
import { useRouter } from 'next/router';
import dynamic from 'next/dynamic';
import withApollo from '../lib/apollo';
import redirectRouteToDomain from '../lib/redirectRouteToDomain';
import { useSiteContext } from '../components/SiteContext';
import loading from '../lib/loading';

const CompanyLayout = dynamic(() => import('../components/Company/Layout'), {
  ssr: true,
  loading,
});

const CompanyProducts = dynamic(() => import(
  '../components/Company/Products'
), {
  ssr: true,
  loading,
});

const CompanyProductsPage = () => {
  const { query: { slug } } = useRouter();
  const { locale } = useSiteContext();

  return (
    <CompanyProducts
      slug={slug}
      locale={locale}
    />
  );
};

CompanyProductsPage.getLayout = (page) => (
  <CompanyLayout layoutMarginBottom="0" throwOnCompanyNotFound>
    {page}
  </CompanyLayout>
);

CompanyProductsPage.getInitialProps = redirectRouteToDomain(
  'company-profile-products',
);

export default withApollo(CompanyProductsPage);
